import React from 'react'
import { Navigation, Pagination, FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import './Slider.scss'

const Slider = ({ name = 'swipe-slider', children, settings = {}, type, prevEl, nextEl }) => {
  let sliderSettings = {
    ...settings,
  }

  if (type === 'horizontal-scroll') {
    sliderSettings = {
      slidesPerView: 'auto',
      freeMode: true,
      ...settings,
      modules: [Navigation, FreeMode],
    }
  }

  if (type === 'highlights') {
    sliderSettings = {
      slidesPerView: 'auto',
      centeredSlides: false,
      spaceBetween: 16,
      slideToClickedSlide: true,
      modules: [Navigation, Pagination],
    }
  }

  // Auto-add the FreeMode module when the caller asks for free dragging so
  // mobile users get a continuous horizontal scroll instead of snapping.
  if (sliderSettings.freeMode) {
    const existing = Array.isArray(sliderSettings.modules) ? sliderSettings.modules : []
    if (!existing.includes(FreeMode)) {
      sliderSettings.modules = [...existing, FreeMode]
    }
  }

  if ((nextEl || prevEl) && !sliderSettings['navigation']) {
    sliderSettings['navigation'] = {}
  }

  if (nextEl) {
    sliderSettings['navigation']['nextEl'] = nextEl
  }

  if (prevEl) {
    sliderSettings['navigation']['prevEl'] = prevEl
  }

  return (
    <Swiper {...sliderSettings} style={{ width: '100%' }}>
      {children.map((el, idx) => (
        <SwiperSlide key={`${name}-slide-${idx}`}>{el}</SwiperSlide>
      ))}
    </Swiper>
  )
}

export default Slider
